module.exports = __webpack_public_path__ + "img/0221d3de0dd94605875c751e4a017818.a850c875.jpg";